import { isEmpty } from 'lodash';
import {
  createValidation,
  validatorRequired,
  validatorLength,
  validatorDateGreaterThen,
} from '../../utils/formValidators';
import { FORMAT_DEFAULT } from '../../utils';
import { tRegister as t } from '../../i18n';

import { formRegisterRepresentativePersonFields } from '../../constants/formRegister';
import dayjs from '../../utils/dayjs';

const mandateLengthValidator = (value, form) => {
  const startDate = form.get(
    formRegisterRepresentativePersonFields.MANDATE_DATE_START
  );

  if (isEmpty(value)) {
    return undefined;
  }

  const start = dayjs(startDate, FORMAT_DEFAULT, true);
  const end = dayjs(value, FORMAT_DEFAULT, true);

  if (!start.isValid() || !end.isValid()) return undefined;

  return end.diff(start, 'day') < 3
    ? t('representation.personMandateLengthError')
    : undefined;
};

export default createValidation([
  {
    name: formRegisterRepresentativePersonFields.FIRST_NAME,
    validators: (field) => validatorRequired()(field),
  },
  {
    name: formRegisterRepresentativePersonFields.LAST_NAME,
    validators: (field) => validatorRequired()(field),
  },
  {
    name: formRegisterRepresentativePersonFields.MANDATE_DATE_START,
    validators: (field) => validatorRequired()(field),
  },
  {
    name: formRegisterRepresentativePersonFields.MANDATE_DATE_END,
    validators: [
      (field) => validatorDateGreaterThen()(field),
      (value, form) => mandateLengthValidator(value, form),
    ],
  },
  {
    name: formRegisterRepresentativePersonFields.PERSONAL_CODE,
    validators: [
      (field) => validatorRequired()(field),
      (field) => validatorLength(11)(field),
    ],
  },
]);
